import { render, staticRenderFns } from "./PaapReferencePreview.vue?vue&type=template&id=56298d0c"
import script from "./PaapReferencePreview.vue?vue&type=script&lang=js"
export * from "./PaapReferencePreview.vue?vue&type=script&lang=js"
import style0 from "@/assets/PaapReferencePreview.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports